import React, { useEffect } from "react";
import MasterComponent from "../../../../../components/Forms";
import { FormInstance } from "antd";
import { MasterConfigs } from "../../../../../interfaces/entity";

const InvoiceNumber = () => {
  const [form, setForm] = React.useState<FormInstance>(null);
  const [previewNumber, setPreviewNumber] = React.useState({});

  function randomNumber(digits) {
    if (digits <= 0) {
      throw new Error("Number of digits must be greater than 0");
    }
    const min = Math.pow(10, digits - 1);
    const max = Math.pow(10, digits) - 1;
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  const InvoiceNumberConfig: MasterConfigs = {
    api: () => '/invoice-number',
    title: 'Invoice Number',
    isActionTab: true,
    modalTitle: (action) => `${action} ${InvoiceNumberConfig.title}`,
    getColumns: () => {
      return [
        {
          title: 'Name',
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: 'Prefix',
          dataIndex: 'prefix',
          key: 'prefix',
        },
        {
          title: 'Degits',
          dataIndex: 'degits',
          key: 'degits',
        },
        {
          title: 'Suffix',
          dataIndex: 'suffix',
          key: 'suffix',
        },
        {
          title: 'Next Number',
          dataIndex: 'nextNumber',
          key: 'nextNumber',
        },
        {
          title: 'Created On',
          dataIndex: 'createdAt',
          key: 'createdAt',
          width: 150,
          render: (date) => {
            return new Date(date).toDateString();
          }
        },
      ];
    },
    getFormColumns: () => {
      return [
        {
          label: 'Serise Name',
          name: 'name',
          type: 'text',
          rules: [{ required: true, message: 'Name is required' }],
        },
        {
          span: 12,
        },
        {
          label: 'Description',
          name: 'description',
          type: 'textarea',
          inputTextAreaProps: { rows: 1 },
        },
        {
          label: 'Prefix',
          name: 'prefix',
          type: 'text',
        },
        {
          label: 'Degits',
          name: 'degits',
          type: 'select',
          children: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((e) => ({ value: e, name: e.toString() })),
        },
        {
          label: 'Suffix',
          name: 'suffix',
          type: 'text',
        },
        {
          label: 'Next Number',
          name: 'nextNumber',
          type: 'number',
        },
        {
          label: 'Number Proview',
          name: 'numberPreview',
          type: 'text',
          inputProps: { disabled: true },
        },
      ];
    },
    combo: [],
    getData: () => ({}),
    actions: [
      { name: 'Add Invoice Number', actionType: 'Add' }
    ],
  };


  useEffect(() => {
    if (form) {
      let nextNumber;
      if (previewNumber['nextNumber']) {
        nextNumber = previewNumber['nextNumber'];
      } else {
        nextNumber = randomNumber(previewNumber['degits']);
      }
      form.setFieldsValue({ numberPreview: [previewNumber['prefix'], nextNumber, previewNumber['suffix']].filter(Boolean).join('-') });
    }
  }, [previewNumber]);


  const UpdateConfig: MasterConfigs = {
    ...InvoiceNumberConfig,
    getFormColumns: () => {
      return InvoiceNumberConfig?.getFormColumns()?.map((column) => {
        if (['prefix', 'suffix',].includes(column.name)) {
          return {
            ...column,
            inputProps: {
              onChange: (e) => setPreviewNumber(prev => ({ ...prev, [column.name]: e.target.value })),
            }
          }
        } else if (column.name === 'degits') {
          return {
            ...column,
            selectProps: {
              onChange: (e) => setPreviewNumber(prev => ({ ...prev, [column.name]: e })),
            }
          }
        } else if (column.name === 'nextNumber') {
          return {
            ...column,
            inputNumberProps: {
              onChange: (e) => setPreviewNumber(prev => ({ ...prev, [column.name]: e })),
            }
          }
        }
        return column;
      })
    }
  }

  return (
    <MasterComponent config={UpdateConfig} form={(e) => setForm(e)} />
  );
}

export default InvoiceNumber; 